import { ClientSelectorComponent } from '../components/client-selector/client-selector.component'
import { ResetPasswordComponent } from '../components/auth/reset-password/reset-password.component'
import {
  ACTIVITY_RECEIVED,
  COMPLETED,
  IN_PROGRESS,
  PENDING_WITH_DEPARTMENT,
  PENDING_WITH_EE,
  PENDING_WITH_ER
} from './stats-cards'

export class GlobalConstants {
  public static readonly DOT = '.'

  public static readonly STATISTICS = {
    ACTIVITY: 'Activity',
    GOVERNMENT_BUSINESS: 'Government Business',
    QUERY: 'Queries'
  }

  public static readonly DATEFORMAT = 'MM/DD/YYYY'

  public static readonly ROUTING = {
    LANDING: '',
    LOGIN: 'login',
    DASHBOARD: 'dashboard',
    ACTIVITY: 'activity',
    GOVERNMENT_BUSINESS: 'government-business',
    QUERY: 'query',
    PROFILE: 'profile',
    SETTINGS: 'settings',
    KNOWLEDGE_HUB: 'knowledge-hub',
    SUMMARY: 'summary',
    NEW: 'new',
    VIEW_OR_EDIT: 'view-edit',
    ID: ':id',
    DETAILS: 'details',
    SEARCH: 'search',
    QUICK_SELECT: 'quick-select',
    VIEW: 'view',
    BULK_IMPORT: 'bulk-import',
    LIST: 'search-list',
    CALENDAR_INFO: 'calendar-info',
    EMPLOYEE_INFO: 'employee-info',
    DATA_REPOSITORY: 'data-repository',
    ANNOUNCEMENT: 'announcement',
    PENDING: 'pending',
    REPORTS: 'reports',
    FORM11_WORKFLOW: 'form11-workflow',
    STATUS: 'status',
    PARAM_STATUS: ':status',
    PARAM_EMPLOYEE_ID: ':eid',
    OFFLINE_TRACKER: 'offline-tracker',
    EDIT: 'edit',
    COMPANY_DOMAIN: ':companyDomain'
  }

  public static readonly SORT_COLUMN = {
    CREATED_DATETIME: 'createdDatetime'
  }

  public static readonly TASK_TYPE = {
    OFFLINE: 'Offline',
    ONLINE: 'Online'
  }

  public static readonly MODULE = {
    ACTIVITY_TRACKER: 'ACTIVITY_TRACKER',
    GOVERNMENT_BUSINESS_TASK: 'GOVERNMENT_BUSINESS_TASK',
    CALENDAR: 'CALENDAR',
    CIRCULAR_AND_COMMUNICATION: 'CIRCULARS_AND_ANNOUNCEMENTS',
    DASHBOARD: 'DASHBOARD',
    KNOWLEDGE_BANK: 'KNOWLEDGE_BANK',
    DOCUMENT_REPOSITORY: 'DOCUMENT_REPOSITORY',
    QUERIES: 'QUERIES',
    OFFLINE_TRACKER: 'OFFLINE_TRACKER'
  }

  public static readonly DOCUMENT_TYPE = {
    ACTIVITY_DOC: 'ACTIVITY_DOC',
    QUERY_DOC: 'QUERY_DOC'
  }

  public static readonly USER_TYPE = {
    RMS_ADMIN: 'RMS_ADMIN',
    EMPLOYEE_ADMIN: 'EMPLOYEE_ADMIN'
  }

  public static readonly DYNAMIC_MODEL = {
    CLIENT_SELECTOR: { key: 'CLIENT_SELECTOR', component: ClientSelectorComponent },
    RESET_PASSWORD: { key: 'RESET_PASSWORD', component: ResetPasswordComponent }
  }

  public static readonly COMPANY_TYPE = {
    ENTITY: 'ENTITY',
    GROUP: 'GROUP'
  }

  public static readonly CATEGORY_TYPE = {
    PT: 'PT',
    LABOUR: 'Labour',
    ESI: 'ESI',
    EPF: 'EPF',
    OTHER_LLC: 'Other LLC',
    LLC: 'LLC' // this type applies only to Knowledge article
  }

  public static readonly COMPANY_SETTINGS_TYPE = {
    MODULES: 'MODULES',
    NOTIFICATION_PREFERENCES: 'NOTIFICATION_PREFERENCES'
  }

  public static readonly NOTIFICATION_PREFERENCES = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
    WHATSAPP: 'WHATSAPP'
  }

  public static readonly FILE_UPLOAD_CONFIG = {
    maxAllowedSizeInBytes: 2097152,
    maxFilesPerSelection: 10,
    allowedFileMimeTypes: [
      'application/pdf',
      'image/jpeg',
      'text/plain',
      'image/png',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'message/rfc822',
      'application/vnd.ms-excel.sheet.macroenabled.12'
    ],
    allowedInputAccept: '.jpeg, .jpg, .png, .pdf, .xls, .xlsx, .doc, .docx, .eml, .xlsm, .txt',
    documentAndMimeTypeMapping: {
      'application/pdf': 'PDF',
      'image/jpeg': 'JPEG',
      'text/plain': 'TXT',
      'image/png': 'PNG',
      'application/vnd.ms-excel': 'EXCEL',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'EXCEL',
      'application/msword': 'DOCX',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
      'message/rfc822': 'EML',
      'application/vnd.ms-excel.sheet.macroenabled.12': 'MACRO ENABLED EXCEL'
    }
  }

  public static readonly DATA_REPO_QUICK_SELECT_OPTIONS = [
    { id: 1, name: 'Employee Documents' },
    { id: 2, name: 'Calendar Events', module: 'CALENDAR' },
    { id: 4, name: 'Activities', module: 'ACTIVITY_TRACKER' }
  ]

  public static readonly DATE_FORMAT = {
    'MM/YYYY': 'MM/YYYY',
    'YYYY/MM': 'YYYY/MM',
    'MM-YYYY': 'MM-YYYY',
    'YYYY-MM': 'YYYY-MM',
    'DD/MM/YYYY': 'DD/MM/YYYY',
    'MM/DD/YYYY': 'MM/DD/YYYY',
    'YYYY/MM/DD': 'YYYY/MM/DD',
    'YYYY/DD/MM': 'YYYY/DD/MM',
    'DD-MM-YYYY': 'DD-MM-YYYY',
    'MM-DD-YYYY': 'MM-DD-YYYY',
    'YYYY-MM-DD': 'YYYY-MM-DD',
    'MM-YYYY-DD': 'MM-YYYY-DD',
    YYYY: 'YYYY'
  }

  public static readonly EMPLOYEE = 'Employee'
  public static readonly EMPLOYER = 'Employer'

  public static readonly FILE_DOWNLOAD_CONFIG = {
    ROW_LIMIT: 1000000,
    PAGE_NUMBER: 0
  }

  public static readonly EMPLOYEE_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    TERMINATED: 'TERMINATED'
  }

  public static readonly ACTIVITY_STATUS_LIST = [
    ACTIVITY_RECEIVED,
    IN_PROGRESS,
    PENDING_WITH_ER,
    PENDING_WITH_DEPARTMENT,
    PENDING_WITH_EE,
    COMPLETED
  ]

  public static readonly KNOWLEDGE_BANK_STATUS_LIST = {
    ACTIVE: 'ACTIVE',
    DRAFT: 'DRAFT'
  }

  public static readonly OPTION_TYPE = {
    QUERY_CATEGORY: 'QUERY_CATEGORY',
    PRIORITY_LEVEL: 'PRIORITY_LEVEL',
    QUERY_TAG: 'QUERY_TAG',
    LOCATION: 'LOCATION',
    MARITAL_TYPE: 'MARITAL_TYPE',
    ACKNOWLEDGE_SHARE_STATUS: 'ACKNOWLEDGE_SHARE_STATUS',
    REQUEST_COMPLETION_STATUS: 'REQUEST_COMPLETION_STATUS',
    RECEIVED_MODE: 'RECEIVED_MODE',
    RECEIVED_DOCUMENTS: 'RECEIVED_DOCUMENTS',
    NATURE_OF_ISSUE: 'NATURE_OF_ISSUE',
    EMPLOYEE_STATUS: 'EMPLOYEE_STATUS',
    STATE: 'STATE',
    GENDER: 'GENDER'
  }
  public static readonly IST_OFFSET: string = 'UTC+0530'

  public static readonly DocType = {
    PAN: 'PAN',
    AADHAAR: 'AADHAAR'
  }

  public static readonly queryReminderOptions = [
    { id: 'reminder3', value: 'THREE_DAY', label: '3 Days' },
    { id: 'reminder5', value: 'FIVE_DAY', label: '5 Days' },
    { id: 'reminderClosure', value: 'CLOSURE', label: 'Closure' },
    { id: 'reminderNone', value: 'NONE', label: 'None' }
  ]
}
